export const avatars = [
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 1",
    },
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 5",
    },
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 1",
    },
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 3",
    },
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 2",
    },
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 3",
    },
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 4",
    },
    {
      src: "https://static.thenounproject.com/png/5598156-512.png",
      alt: "Avatar 5",
    },
  ];
  
  export  const successStories = [
    {
      userImg: "https://static.thenounproject.com/png/5598156-512.png",
      name: "Priyanshu Agarwal",
      role: "UI/UX DESIGNER",
      hike: "67% Hike",
      company:
        "https://e7.pngegg.com/pngimages/470/798/png-clipart-graphic-design-art-creativity-design-leaf-logo.png", // Comany logo
      details: "Got Promoted from Deep Learning Intern at UI/UX Designer",
    },
    {
      userImg: "https://static.thenounproject.com/png/5598156-512.png",
      name: "Priyanshu Agarwal",
      role: "UI/UX DESIGNER",
      hike: "67% Hike",
      company:
        "https://e7.pngegg.com/pngimages/470/798/png-clipart-graphic-design-art-creativity-design-leaf-logo.png", // Comany logo
      details: "Got Promoted from Deep Learning Intern at UI/UX Designer",
    },
    {
      userImg: "https://static.thenounproject.com/png/5598156-512.png",
      name: "Priyanshu Agarwal",
      role: "UI/UX DESIGNER",
      hike: "67% Hike",
      company:
        "https://e7.pngegg.com/pngimages/470/798/png-clipart-graphic-design-art-creativity-design-leaf-logo.png", // Comany logo
      details: "Got Promoted from Deep Learning Intern at UI/UX Designer",
    },
    {
      userImg: "https://static.thenounproject.com/png/5598156-512.png",
      name: "Priyanshu Agarwal",
      role: "UI/UX DESIGNER",
      hike: "67% Hike",
      company:
        "https://e7.pngegg.com/pngimages/470/798/png-clipart-graphic-design-art-creativity-design-leaf-logo.png", // Comany logo
      details: "Got Promoted from Deep Learning Intern at UI/UX Designer",
    },
    {
      userImg: "https://static.thenounproject.com/png/5598156-512.png",
      name: "Priyanshu Agarwal",
      role: "UI/UX DESIGNER",
      hike: "67% Hike",
      company:
        "https://e7.pngegg.com/pngimages/470/798/png-clipart-graphic-design-art-creativity-design-leaf-logo.png", // Comany logo
      details: "Got Promoted from Deep Learning Intern at UI/UX Designer",
    },
    {
      userImg: "https://static.thenounproject.com/png/5598156-512.png",
      name: "Priyanshu Agarwal",
      role: "UI/UX DESIGNER",
      hike: "67% Hike",
      company:
        "https://e7.pngegg.com/pngimages/470/798/png-clipart-graphic-design-art-creativity-design-leaf-logo.png", // Comany logo
      details: "Got Promoted from Deep Learning Intern at UI/UX Designer",
    },
  ];
  
  export const stats = [
    { value: "80%", label: "Alumni Career Transitions" },
    { value: "3500+", label: "Hiring Companies" },
    { value: "70+", label: "Avg Salary Hike" },
  ];